export const ASSETS_CDN = 'https://cdn.cryptomines.app/videos';
//src/assets/video/spaceships/rank3/_3.mp4
// export const ASSETS_CDN = 'https://res.cloudinary.com/vac/video/upload/q_auto:eco/v1630828950/cryptomines/assets';
